module.exports = __webpack_public_path__ + "img/CDT32_0062782.e2a329ea.jpg";